export const ROUTES = {
  BOOKING_REQUESTS: '/booking-requests',
  BOOKING_REQUESTS_NEW: '/booking-requests/new',
  INSPECTIONS: '/inspections',
  INSPECTION_DETAIL: '/inspections',
  LOGIN: '/',
  ERROR: '/error',
  UNAUTHORIZED: '/unauthorized',
  NOT_FOUND: '*',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RouteValue = (typeof ROUTES)[RouteKey];
